import { handleActions } from 'redux-actions'

import {
  createCategoryRequest,
  createCategorySucceed,
  getCategoryDetailRequest,
  getCategoryDetailSucceed,
  getCategoryListRequest,
  getCategoryListSucceed,
  requestFailure,
  updateCategoryRequest,
  updateCategorySucceed
} from './actions'

export const INITIAL_STATE = {
  processing: {
    getCategoryList: false,
    getCategoryDetail: false,
    createOrUpdatingCategory: false
  },
  categoryList: null,
  categoryDetail: null
}

type State = typeof INITIAL_STATE

export const categoryReducer = handleActions<State, any>(
  {
    [getCategoryListRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        getCategoryList: true
      }
    }),
    [getCategoryListSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        getCategoryList: false
      },
      categoryList: payload
    }),
    [getCategoryDetailRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        getCategoryDetail: true
      }
    }),
    [getCategoryDetailSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        getCategoryDetail: false
      },
      categoryDetail: payload
    }),
    [createCategoryRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingCategory: true
      }
    }),
    [createCategorySucceed.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingCategory: false
      }
    }),
    [updateCategoryRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingCategory: true
      }
    }),
    [updateCategorySucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingCategory: false
      },
      categoryDetail: payload
    }),
    [requestFailure.toString()]: (state) => ({
      ...state,
      processing: INITIAL_STATE.processing
    })
  },
  INITIAL_STATE
)
